import React from "react";
import messageVariations from "./variations";
import { getSecureImage } from "../../../services/DashboardDesigner/widgetService";

export default ({ type, text, style, imgStyle, textStyle, textClasses }) => (
	<div
		className="noinfo d-flex flex-column align-items-center justify-content-end"
		style={{ height: "50vh", ...style }}
	>
		<div className="noinfo-icon" style={{ ...imgStyle }}>
			<img
				style={{ height: "100%" }}
				src={
					messageVariations.hasOwnProperty(type)
						? getSecureImage(messageVariations[type])
						: getSecureImage(messageVariations["defaultImage"])
				}
			/>
		</div>
		<div className={textClasses ? textClasses : "noinfo-text mt-3"} style={{ ...textStyle }}>
			<p>{text}</p>
		</div>
	</div>
);
